import React from "react";
import { Helmet } from "react-helmet-async";

function Seo({
  title = "BudgetMate – Smart Budget & Expense Tracker",
  description = "BudgetMate helps you track expenses, manage salary, and stay in control of your finances.",
  keywords = "budget app, expense tracker, salary management, finance app",
  canonical = window.location.href,
}) {
  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>

      {/* Primary Meta */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="BudgetMate" />
      <meta name="robots" content="index, follow" />

      {/* Canonical */}
      <link rel="canonical" href={canonical} />

      {/* Open Graph (Social Sharing) */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="BudgetMate" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}

export default Seo;
